import * as Sentry from "@sentry/react";

export const initSentry = () => {
  Sentry.init({
    // Your Sentry project DSN
    dsn: "https://ae0638ce2f8660762907a477c2ddd31e@o4509855768248320.ingest.us.sentry.io/4509855780306944",
    
    // Environment
    environment: import.meta.env.MODE || "development",
    
    // Basic configuration without problematic integrations
    // Remove browser tracing and replay for now to fix PWA issues
    integrations: [],
    
    // Disable performance tracking for now
    tracesSampleRate: 0,
    
    // Release tracking
    release: import.meta.env.VITE_APP_VERSION || "1.0.0",
    
    // Additional configuration
    beforeSend(event) {
      // Filter out development errors
      if (import.meta.env.MODE === "development") {
        console.log("Sentry event:", event);
      }
      
      // Filter out non-critical errors
      if (event.exception?.values?.[0]?.value?.includes('ResizeObserver loop limit exceeded')) {
        return null; // Don't send this common non-critical error
      }
      
      return event;
    },
    
    // Ignore certain URLs/errors
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
      'Network request failed',
      /extension\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
    ],
  });
};
    
// Utility functions for manual error reporting
export const captureError = (error: Error, context?: Record<string, any>) => {
  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext("additional_info", context);
      
      // Add breadcrumbs for better debugging
      scope.addBreadcrumb({
        message: 'Error occurred',
        level: 'error',
        data: context,
      });
    }
    Sentry.captureException(error);
  });
};

export const captureMessage = (message: string, level: Sentry.SeverityLevel = "info", context?: Record<string, any>) => {
  Sentry.withScope((scope) => {
    if (context) {
      scope.setContext("message_context", context);
    }
    Sentry.captureMessage(message, level);
  });
};

// Set user context for better error tracking
export const setUserContext = (user: { id: string; email?: string; phone?: string; role?: string }) => {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.phone,
    role: user.role,
  });
};

// Clear user context on logout
export const clearUserContext = () => {
  Sentry.setUser(null);
};